import * as React from "react";
import i18n from "i18n";
import Icon from "components/common/Icon";
import MessagesWidget from "views/logic/widgets/MessagesWidget";
import LogViewWidget from "logview/logic/LogViewWidget";
import { updateWidget } from "views/logic/slices/widgetActions";
import validLicensePresent from "../license/ValidLicensePresent";
const CreateLogViewFromMessageTable = {
  type: "toggle-log-view",
  position: "dropdown",
  action: (messageTable, { widgetFocusContext: { focusedWidget, setWidgetFocusing } }) => (dispatch) => {
    if ((focusedWidget == null ? void 0 : focusedWidget.id) !== messageTable.id) {
      setWidgetFocusing(messageTable.id);
    }
    const logViewWidget = LogViewWidget.fromMessageTable(messageTable);
    return dispatch(updateWidget(messageTable.id, logViewWidget));
  },
  isHidden: (w) => w.type !== MessagesWidget.type,
  title: () => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Icon, { name: "open_with" }), " ", i18n.t("create_log_view_from_message_table.switch_to_log_view", { ns: "enterprise_search" })),
  disabled: () => !validLicensePresent()
};
export default CreateLogViewFromMessageTable;
